var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTubeStand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 106,
    fill: "none",
    viewBox: "0 0 98 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00AEEF",
    d: "M3 98h92v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99DFF9",
    d: "M5 96h88l2 2H3l2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AEEF",
    d: "M3 59h92v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008BC0",
    fillRule: "evenodd",
    d: "M93 64h-7v-1H70v1H56.8v-1h-16v1H5l-2-2h92l-2 2zm-65-1H12v1h16v-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AEEF",
    d: "M5 63h2v34H5zM90 63h2v34h-2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.5,
    cy: 96.5,
    fill: "#000",
    fillOpacity: 0.3,
    rx: 8.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.5,
    cy: 96.5,
    fill: "#000",
    fillOpacity: 0.3,
    rx: 8.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 96.5,
    fill: "#000",
    fillOpacity: 0.3,
    rx: 8.5,
    ry: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 98,
    height: 107,
    x: 0,
    y: -1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTubeStand);
export default __webpack_public_path__ + "static/media/empty-tube-stand.8b414c9f138f7d45239683eac8750adf.svg";
export { ForwardRef as ReactComponent };